const INTERNAL_CHAT_AUTH_CLOSE_CODES = new Set([1008, 4001, 4003, 4401, 4403]);

export const isInternalChatAuthCloseEvent = (event) => {
  const code = Number(event?.code);
  if (INTERNAL_CHAT_AUTH_CLOSE_CODES.has(code)) {
    return true;
  }

  const reason = String(event?.reason || '').toLowerCase();
  return (
    reason.includes('auth') ||
    reason.includes('invalid attendant') ||
    reason.includes('policy violation')
  );
};

export const isSessionHealthAuthFailure = (health) => {
  if (!health || health.allowed) return false;

  const status = health.status ?? health.reason?.status ?? health.reason?.response?.status;
  if (status === 401 || status === 403) {
    return true;
  }

  const reason = String(health.reason || '').toLowerCase();
  return (
    reason.includes('auth 401') ||
    reason.includes('auth 403') ||
    reason.includes('unauthorized') ||
    reason.includes('forbidden')
  );
};
